import React, { useState } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { classNames } from "../../../../shared/utility";
import { formatUnitOfMeasure } from "../../../../shared/formatUnitOfMeasure";
import Button from "../../../ui/Button";

export default function ManufactureRecipeItemsTable(props) {
  const {
    selectedRecipe,
    values,
    openAssemblyItemPopUpToAddToProduct,
    openReceivingItemInformation,
    askDeleteProductionIngredient,
    isTraceability,
    showInStock = true,
    showTitle = true,
    readOnlyGuide = false,
  } = props;

  const [expandedRows, setExpandedRows] = useState(null);

  const allowExpansion = (rowData) => {
    if (readOnlyGuide) {
      return false;
    }
    const receivingItems = rowData.receivingItems ? rowData.receivingItems : [];
    return receivingItems.length > 0;
  };

  const assemblyItemActionTemplate = (rowData) => {
    return (
      <div className="ml-10">
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => {
            openAssemblyItemPopUpToAddToProduct(rowData, true);
          }}
          className={classNames(isTraceability ? "hidden" : null)}
        >
          Edit
        </Button>
        <Button
          type="button"
          variant="primary"
          size="sm"
          onClick={() => {
            openReceivingItemInformation(rowData);
          }}
          className="ml-2"
        >
          Receiving Info
        </Button>
        <Button
          type="button"
          variant="danger"
          size="sm"
          onClick={() => askDeleteProductionIngredient(rowData)}
          className={classNames(isTraceability ? "hidden" : null, "ml-2")}
        >
          Delete
        </Button>
      </div>
    );
  };

  const barcodeBody = (rowData) => {
    const text = rowData.barcode;
    const displayText = text && text.length > 9 ? text.slice(-9) : text || "";
    return <p>...{displayText}</p>;
  };

  function subItemUsedAmount(rowData) {
    return (
      <p>
        {rowData.ingredient_amount_used}{" "}
        {formatUnitOfMeasure(rowData.unit_of_measure)}
      </p>
    );
  }

  function itemUsedAmount(rowData) {
    return (
      <p>
        {rowData.amount_in_use}{" "}
        {formatUnitOfMeasure(
          rowData.unit_of_measure_label ?? rowData.unit_of_measure,
        )}
      </p>
    );
  }

  const totalCostBodyTemplate = (rowData) => {
    const amount = rowData?.total_cost;
    if (amount == null || amount === "") {
      return <p className="w-full text-right">$0.00</p>;
    }
    return <p className="w-full text-right">${amount}</p>;
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-3">
        {/* <h5>Orders for {data.name}</h5> */}
        <DataTable
          value={data.receivingItems}
          tableClassName="min-w-full bg-white divide-y divide-gray-300 manufacture-recipe-items-children-table"
          cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2"
        >
          <Column field="lot_number" header="Lot Number"></Column>
          <Column body={barcodeBody} header="Barcode Serial"></Column>
          <Column field="supplier_name" header="Supplier"></Column>
          <Column field="plu" header="Item Plu"></Column>
          <Column field="product_name" header="Item Name"></Column>
          <Column
            header="Used Unit"
            style={{ textAlign: "right" }}
            body={subItemUsedAmount}
          ></Column>
          <Column header="" body={assemblyItemActionTemplate} />
        </DataTable>
      </div>
    );
  };

  const requiredAmountBodyTemplate = (rowData) => {
    return (
      <p>
        {rowData.amount_required} {rowData.unit_of_measure_label}
      </p>
    );
  };

  const inStockBodyTemplate = (rowData) => {
    const recipePerKg =
      rowData?.recipe_per_kg != null ? parseFloat(rowData.recipe_per_kg) : 0;
    const newWeight =
      values?.new_weight != null ? parseFloat(values.new_weight) : 0;
    const totalRequired = (recipePerKg * newWeight).toFixed(2);

    const inStockAmount = rowData?.in_stock_amount;
    const cleanNumber =
      inStockAmount != null
        ? parseFloat(
            parseFloat(String(inStockAmount).replace(/,/g, "")).toFixed(2),
          )
        : 0;
    const isEnoughInStock =
      cleanNumber >= parseFloat(totalRequired) && cleanNumber > 0;

    return (
      <p
        class={classNames(
          isEnoughInStock ? "text-green-700" : "text-[#DC2626]",
        )}
      >
        {inStockAmount != null ? cleanNumber.toFixed(2) : ""}{" "}
        {rowData?.unit_of_measure_label ?? ""}
      </p>
    );
  };

  return (
    <div className="flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          {showTitle ? (
            <h3 className="text-lg mb-2">Recipe ingredients (Guide)</h3>
          ) : null}
          <div className="overflow-hidden card-custom bg-white">
            <DataTable
              value={selectedRecipe.recipeItems}
              expandedRows={expandedRows}
              onRowToggle={(e) => {
                setExpandedRows(e.data);
              }}
              rowExpansionTemplate={rowExpansionTemplate}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 manufacture-recipe-items-table"
              cellClassName="py-2 bg-gray-100 border-1-bottom-gray"
            >
              <Column field="bom_plu" header="BOM Plu" />
              <Column field="bom_name" header="BOM name" />
              <Column
                header="Required amount"
                body={requiredAmountBodyTemplate}
                style={{ textAlign: "right" }}
              />
              {showInStock ? (
                <Column
                  header="In stock"
                  body={inStockBodyTemplate}
                  style={{ textAlign: "right" }}
                />
              ) : null}

              <Column
                header="Amount in use"
                body={itemUsedAmount}
                style={{ textAlign: "right" }}
              />
              {isTraceability || readOnlyGuide ? null : (
                <Column
                  header="Total ($)"
                  body={totalCostBodyTemplate}
                  style={{ textAlign: "right" }}
                />
              )}

              {/* <Column field="price" header="Price" body={priceBodyTemplate} /> */}
              {readOnlyGuide ? null : (
                <Column expander={allowExpansion} style={{ width: "5rem" }} />
              )}
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
}
